import * as angular from 'angular';
import * as angulartics from 'angulartics';
import * as ngCookies from 'angular-cookies';
import * as angularTranslate from 'angular-translate';
import * as uiTooltip from 'angular-ui-bootstrap/src/tooltip';
import * as angularMaterial from 'angular-material';
import * as angularAria from 'angular-aria';
import * as angularSanitize from 'angular-sanitize';

import { sessionManager } from '../session-manager';
import { sessionEditorModule } from '../session-editor';
import { goModal } from '../modals';
import { confirmModalModule } from '../modals/confirm';
import { userModel } from '../models/user';
import { groupDepModel } from '../models/group-dep';
import { sessionModel } from '../models/session';
import { commentModel } from '../models/comment';
import { rubricSessionModel } from '../models/rubric-session';
import { syncEventModel } from '../models/sync-event';
import { mediaModel } from '../models/media';
import { fineUploaderModule } from '../fine-uploader';
import { richDropdownModule } from '../rich-dropdown';
import { goPopoverModule } from '../go-popover';
import { sessionAttachments } from '../session-attachments';
import { mediaPreviewModule } from '../media-preview';
import { presenterListModule } from 'go-modules/presenter-list';
import { event } from '../event-channel';
import { mediaPlayerModule } from '../media-player';
import { playerSyncModule } from '../player-sync';
import { detectModule } from '../detect';
import { goPubnubModule } from 'go-modules/go-pubnub';
import { goStorageModule } from '../go-storage';
import { timerModule } from '../timer';
import { NgxUiTimerModule } from '@go-modules/directives/ui-timer';
import { commonFiltersModule } from '../common-filters';
import { rubricModule } from '../rubric';
import { helpUrlsModule } from '../help-urls';
import { labelInputModule } from '../label-input';
import { slideToggleModule } from '../slide-toggle';
import { activityTemplateModel } from 'go-modules/models/activity-template';

import { sessionEditorModalModule } from '../modals/session-editor';
import { activityInstructionsModalModule } from '../modals/activity-instructions';
import { rubricFeedbackViewerModule } from '../rubric-feedback-viewer/index';
import { messageModalModule } from 'go-modules/modals/message';
import { ngxUnsavedDataManagerServiceModule } from '@go-modules/services/unsaved-data-manager';
import { postDiscardSessionModalModule } from 'go-modules/modals/post-discard-session';
import { ngxFeatureFlagServiceModule } from '@go-modules/services/feature-flag';
import { sanitizerServiceModule } from 'go-modules/services/xss';
import { $debounceModule } from 'go-modules/services/$debounce';

import {FeedbackSessionController} from './feedback-session.controller';
import feedbackSessionComponentDefinition from './feedback-session.component';
import { FeedbackSessionProvider } from './feedback-session.provider';
import {bgSplitter} from './bg-splitter/bg-splitter.component';
import {bgHandle} from './bg-splitter/bg-handle/bg-handle.component';
import {templates} from './templates';
import {FeedbackSessionContentController} from './content/content.controller';
import {feedbackSessionContent} from './content/content.component';
import {feedbackDisplay} from './feedback-display/feedback-display.directive';
import {feedbackSessionStatus} from './filters/status.filter';
import {feedbackSessionHeader} from './header/header.component';
import {mediaDisplay} from './media-display/media-display.component';
import {multiMediaDisplay} from './multi-media-display/multi-media-display.component';
import {DocumentMediaPlayer} from './services/document-media-player.factory';
import {featureCache} from './services/feature-cache.service';
import {SessionFeedback} from './services/session-feedback.factory';
import {TimingOrchestratorService} from './services/timing-orchestrator.service';
import {GoRecorderManagerService} from './services/go-recorder-manager.service';
import {sessionMediaDisplay} from './session-media-display/session-media-display.component';
import {playbackViewComponent} from './session-media-display/playback-view/view.component';
import {liveViewComponent} from './session-media-display/live-view/view.component';
import {singleMediaDisplay} from './single-media-display/single-media-display.component';
import {slidePresentationViewer} from './slide-presentation-viewer/slide-presentation-viewer.component';
import {slideDeckViewer} from './slide-presentation-viewer/slide-deck-viewer/slide-deck-viewer.component';
import {slideDeckItemRenderer} from './slide-presentation-viewer/slide-deck-viewer/item-renderer/item-renderer.component';
import {slideDeckInstructions} from './slide-presentation-viewer/slide-deck-viewer/slide-deck-instructions/slide-deck-instructions.component';
import {SlideDeckViewerSyncEventToastController} from './slide-presentation-viewer/slide-deck-viewer/sync-event-toast/toast.controller';
import {stimulusResponseViewer} from './stimulus-response-viewer/stimulus-response-viewer.component';
import {stimulusDocumentViewer} from './stimulus-response-viewer/stimulus-document-viewer/stimulus-document-viewer.component';
import {stimulusMediaDisplay} from './stimulus-response-viewer/stimulus-media-display/stimulus-media-display.component';
import {stimulusVideoViewer} from './stimulus-response-viewer/stimulus-video-viewer/stimulus-video-viewer.component';
import { responsiveViewModule } from 'go-modules/responsive-view';
import { ngxFeedbackCreatorModule } from '@go-modules/components/feedback-session/feedback-creator';
import { ngxTranscriptViewerModule } from '@go-modules/components/feedback-session/transcript-viewer';
import { ngxSessionAnalyticsModule } from '@go-modules/components/feedback-session/session-analytics';
import { SelectedModule } from 'go-modules/services/selected';
import { ngxSpeedGraderModule } from '@go-modules/components/feedback-session/speed-grader';
import { ngxFeedbackSessionRecordViewModule } from '@go-modules/components/feedback-session-record-view';

import 'angular-material/modules/layouts/angular-material.layouts.css';
import 'angular-material/modules/js/core/core.css';
import 'angular-material/modules/js/button/button.css';
import 'angular-material/modules/js/switch/switch.css';
import 'angular-material/modules/js/toast/toast.css';
import 'nouislider/distribute/nouislider.css';
import 'bootstrap-css-only';

import './style.less';
import { goTablistKeyboardNavigationModule } from 'go-modules/go-tablist-keyboard-navigation';
import { ngxDowngradeModalServiceModule } from '@go-modules/services/downgrade-modal';
import { ngxMarkerModule } from '@go-modules/components/marker';
import { ngxGoModalServiceModule } from '@go-modules/services/go-modal';

// Circular dependency
import /*{ universalMediaChooserModule } from*/ '../universal-media-chooser';
import { ngxCommentFilterServiceModule } from '@go-modules/services/comment-filter';
import { goTourModule } from 'go-modules/go-tour';
import { transcriptionServiceModule } from '@go-modules/services/transcription';
import { ngxVideoShareDialogServiceModule } from '@go-modules/components/dialogs/video-share-dialog';
import { ngxSessionServiceModule } from '@go-modules/services/session';
import { ngxCommentCaptionsModule } from '@go-modules/components/comment-captions';
import { llmTaskServiceModule } from '@go-modules/services/llm-task';
import { ngxCommentViewerModule } from '@go-modules/components/feedback-session/comment-viewer';
import { ngxCommentListServiceModule } from '@go-modules/services/comment-list';
import { ngxActivityInfoModule } from '@go-modules/components/activity-info';
import { ngxFeedbackPanelTabsModule } from '@go-modules/components/feedback-session/feedback-panel-tabs';
import { ngxFeedbackSessionServiceModule } from '@go-modules/services/feedback-session';
import { transcriptCacheServiceModule } from '@go-modules/services/transcript-cache';
import { internetStatusModule } from 'go-modules/internet-status';
import { ngxFeedbackDisplayHeaderModule } from '@go-modules/components/feedback-session/feedback-display-header';
import { ngxCommentPanelModule } from '@go-modules/components/feedback-session/comment-panel';
import { attachmentServiceModule } from 'go-modules/services/attachment';
import { ngxTaskServiceModule } from '@go-modules/services/task';
import { ngxCommentSyncEventViewerModule } from '@go-modules/components/feedback-session/comment-sync-event-viewer';

export const feedbackSessionModule = angular.module('go.feedbackSession', [
	sessionManager,
	ngCookies,
	sessionEditorModule,
	goModal,
	confirmModalModule,
	userModel,
	groupDepModel,
	sessionModel,
	commentModel,
	attachmentServiceModule,
	rubricSessionModel,
	syncEventModel,
	mediaModel,
	fineUploaderModule,
	richDropdownModule,
	goPopoverModule,
	sessionAttachments,
	mediaPreviewModule,
	presenterListModule,
	event,
	mediaPlayerModule,
	playerSyncModule,
	detectModule,
	goPubnubModule,
	goStorageModule,
	ngxFeatureFlagServiceModule,
	timerModule,
	NgxUiTimerModule,
	commonFiltersModule,
	rubricModule,
	helpUrlsModule,
	labelInputModule,
	angularAria,
	angularSanitize,
	uiTooltip,
	angulartics,
	angularTranslate,
	angularMaterial,
	sessionEditorModalModule,
	activityInstructionsModalModule,
	rubricFeedbackViewerModule,
	slideToggleModule,
	messageModalModule,
	ngxUnsavedDataManagerServiceModule,
	postDiscardSessionModalModule,
	activityTemplateModel,
	sanitizerServiceModule,
	$debounceModule,
	goTablistKeyboardNavigationModule,
	responsiveViewModule,
	ngxFeedbackCreatorModule,
	ngxTranscriptViewerModule,
	ngxSessionAnalyticsModule,
	SelectedModule,
	ngxSpeedGraderModule,
	ngxDowngradeModalServiceModule,
	ngxMarkerModule,
	ngxCommentFilterServiceModule,
	ngxGoModalServiceModule,
	goTourModule,
	transcriptionServiceModule,
	transcriptCacheServiceModule,
	ngxVideoShareDialogServiceModule,
	ngxSessionServiceModule,
	ngxCommentCaptionsModule,
	llmTaskServiceModule,
	ngxCommentViewerModule,
	ngxCommentListServiceModule,
	ngxActivityInfoModule,
	ngxFeedbackPanelTabsModule,
	ngxFeedbackSessionServiceModule,
	internetStatusModule,
	ngxFeedbackDisplayHeaderModule,
	ngxCommentPanelModule,
	ngxFeedbackSessionRecordViewModule,
	ngxTaskServiceModule,
	ngxCommentSyncEventViewerModule,
	'universal-media-chooser'
])
	.run(templates)
	.controller('FeedbackSessionController', FeedbackSessionController)
	.component('feedbackSession', feedbackSessionComponentDefinition)
	.provider('feedbackSession', FeedbackSessionProvider)
	.component('bgSplitter', bgSplitter)
	.component('bgHandle', bgHandle)
	.controller('FeedbackSessionContentController', FeedbackSessionContentController)
	.component('feedbackSessionContent', feedbackSessionContent)
	.directive('feedbackDisplay', feedbackDisplay)
	.filter('feedbackSessionStatus', feedbackSessionStatus)
	.component('feedbackSessionHeader', feedbackSessionHeader)
	.component('mediaDisplay', mediaDisplay)
	.component('multiMediaDisplay', multiMediaDisplay)
	.factory('DocumentMediaPlayer', DocumentMediaPlayer)
	.service('featureCache', featureCache)
	.factory('SessionFeedback', SessionFeedback)
	.service('TimingOrchestrator', TimingOrchestratorService)
	.service('goRecorderManagerService', GoRecorderManagerService)
	.component('sessionMediaDisplay', sessionMediaDisplay)
	.component('feedbackSessionPlaybackView', playbackViewComponent)
	.component('feedbackSessionLiveView', liveViewComponent)
	.component('singleMediaDisplay', singleMediaDisplay)
	.component('slidePresentationViewer', slidePresentationViewer)
	.component('slideDeckViewer', slideDeckViewer)
	.component('slideDeckItemRenderer', slideDeckItemRenderer)
	.component('slideDeckInstructions', slideDeckInstructions)
	.controller('SlideDeckViewerSyncEventToastController', SlideDeckViewerSyncEventToastController)
	.component('stimulusResponseViewer', stimulusResponseViewer)
	.component('stimulusDocumentViewer', stimulusDocumentViewer)
	.component('stimulusMediaDisplay', stimulusMediaDisplay)
	.component('stimulusVideoViewer', stimulusVideoViewer)
	.name;
